var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutlineUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.195,
    height: 12.195,
    viewBox: "0 0 12.195 12.195",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-108 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(108 188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.922,5.844A2.922,2.922,0,1,1,5.844,2.922,2.925,2.925,0,0,1,2.922,5.844Zm0-5.081a2.16,2.16,0,1,0,2.16,2.16A2.164,2.164,0,0,0,2.922.762Z",
    transform: "translate(3.176 0.635)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.111,4.319a.384.384,0,0,1-.381-.381C8.73,2.185,6.941.762,4.746.762S.762,2.185.762,3.938a.384.384,0,0,1-.381.381A.384.384,0,0,1,0,3.938C0,1.768,2.129,0,4.746,0S9.492,1.768,9.492,3.938A.384.384,0,0,1,9.111,4.319Z",
    transform: "translate(1.352 7.241)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H12.2V12.2H0Z",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineUser);
export default __webpack_public_path__ + "static/media/outlineUser.180adcea481b654f3689d5edb0bc3850.svg";
export { ForwardRef as ReactComponent };